import { render, staticRenderFns } from "./GrupoGrid.vue?vue&type=template&id=f5966b34&"
import script from "./GrupoGrid.vue?vue&type=script&lang=js&"
export * from "./GrupoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GrupoGrid.vue"
export default component.exports